import { Box, Input, Link } from "components/base";
import { Container, ContainerFluid, Flex } from "components/base/container";
import { useWallet } from "@manahippo/aptos-wallet-adapter";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { CustomSelect, SmOption } from "components/form";
import { useAppDispatch, useAppSelector } from "store/store.hook";
import { setDetailSettingStep1Value, setDetailSettingStep2Value } from "store/store.slice.settingDetail";
import { ConfirmValueBox, DetailSetupInput, DetailSetupInputTitle, DetailSetupNumInput } from "./setupDetail.comp";
import { MODULE_ADDR, RewardTokenList } from "config";
import { NormalBtn } from "components/element/element.button";

const SetupDetailPage = () => {
  const navigate = useNavigate();
  const { connected, account, signAndSubmitTransaction } = useWallet();
  useEffect(() => {
    if (!connected) {
      navigate("/");
    }
  }, [connected]);
  const [currentStep, setCurrentStep] = useState(0);

  const detailSetupVaules = useAppSelector((store) => store.settingDetailInfor);

  const start_pool = async () => {
    if (!connected) return;

    const { twitterLink, discordLink, telegramLink } = detailSetupVaules.step2;

    const {
      nameOfCollection,
      description,
      imageURL,
      collectionCreatorAddress,
      duration,
      totalNftCount,
    } = detailSetupVaules.step1;

    const dailyRewardAmount = detailSetupVaules.step1.dailyRewardAmount * 100000000;

    let deposit_coin_amount = totalNftCount * dailyRewardAmount * duration;
    let rewardToken = RewardTokenList[detailSetupVaules.step1.rewardToken];
    const transaction = {
      type: "entry_function_payload",
      function: `${MODULE_ADDR}::snore::startPool`,
      arguments: [
        collectionCreatorAddress,
        nameOfCollection,
        description,
        imageURL,
        totalNftCount,
        duration*86400,
        dailyRewardAmount,
        deposit_coin_amount,
        twitterLink,
        discordLink,
        telegramLink
      ],
      type_arguments: [rewardToken],
    };
    try {
      const result = await signAndSubmitTransaction(transaction);
      console.log(result.hash);
      navigate("/");
    } catch (error) {
      console.log(error);
    }
  };
  return (
    <ContainerFluid>
      <Container col py={["60px", "60px", "80px", "100px"]}>
        <Flex col>
          <Flex alignCenter justifyContent={"space-between"} px={["30px", "30px", "60px", "90px"]} pb={"24px"} color={"white"}>
            <Flex col alignCenter position={"relative"}>
              <Flex
                justifyCenter
                alignCenter
                bg={currentStep >= 0 ? "#F2C65B" : "#301D3D"}
                aspectRatio={"1"}
                width={"24px"}
                borderRadius={"100%"}
                color={currentStep >= 0 ? "bg" : "white"}
              >
                1
              </Flex>
              <Flex mt={"32px"} position={"absolute"} whiteSpace={"nowrap"}>
                Project Info
              </Flex>
            </Flex>
            <Flex bg={currentStep >= 1 ? "#F2C65B" : "#301D3D"} flex={"1"} height={"8px"} />
            <Flex col alignCenter position={"relative"}>
              <Flex
                justifyCenter
                alignCenter
                aspectRatio={"1"}
                width={"24px"}
                borderRadius={"100%"}
                bg={currentStep >= 1 ? "#F2C65B" : "#301D3D"}
                color={currentStep >= 1 ? "bg" : "white"}
              >
                2
              </Flex>
              <Flex mt={"32px"} position={"absolute"} whiteSpace={"nowrap"}>
                Contact Details
              </Flex>
            </Flex>
            <Flex bg={currentStep >= 2 ? "#F2C65B" : "#301D3D"} flex={"1"} height={"8px"} />
            <Flex col alignCenter position={"relative"}>
              <Flex
                justifyCenter
                alignCenter
                aspectRatio={"1"}
                width={"24px"}
                borderRadius={"100%"}
                bg={currentStep >= 2 ? "#F2C65B" : "#301D3D"}
                color={currentStep >= 2 ? "bg" : "white"}
              >
                3
              </Flex>
              <Flex mt={"32px"} position={"absolute"} whiteSpace={"nowrap"}>
                Confirmation
              </Flex>
            </Flex>
          </Flex>
        </Flex>
        <Flex
          col
          gridGap={["44px", "44px", "64px", "84px"]}
          mt={["32px", "32px", "52px", "72px"]}
          bg={"normal"}
          p={"72px 36px"}
          borderRadius={"24px"}
        >
          {currentStep === 0 && <FirstStepSection />}
          {currentStep === 1 && <SecondStepSection />}
          {currentStep === 2 && <LastStepSection />}
          <Flex justifyContent={"flex-end"} gridGap={"30px"}>
            {currentStep >= 1 && (
              <NormalBtn
                background={"none"}
                onClick={() => {
                  setCurrentStep(currentStep - 1);
                }}
              >
                Back
              </NormalBtn>
            )}
            <NormalBtn
              border={"none"}
              onClick={() => {
                currentStep % 3 === 2 ? start_pool() : setCurrentStep(currentStep + 1);
              }}
            >
              {currentStep % 3 === 2 ? "Confirm" : "Continue"}
            </NormalBtn>
          </Flex>
        </Flex>
      </Container>
    </ContainerFluid>
  );
};

const FirstStepSection = () => {
  const {
    collectionCreatorAddress,
    description,
    nameOfCollection,
    imageURL,
    totalNftCount,
    dailyRewardAmount,
    duration,
    rewardToken,
  } = useAppSelector((store) => store.settingDetailInfor.step1);
  const dispatch = useAppDispatch();
  const updateValues = (arg: object) => {
    dispatch(
      setDetailSettingStep1Value({
        collectionCreatorAddress,
        description,
        nameOfCollection,
        imageURL,
        totalNftCount,
        dailyRewardAmount,
        duration,
        rewardToken,
        ...arg,
      })
    );
  };
  return (
    <>
      <Flex gridGap={"32px"} flexDirection={["column", "column", "row"]}>
        <Flex col flex={3} gridGap={"8px"} width={["100%", "100%", "0px"]}>
          <Flex color={"white"} fontWeight={"700"} fontSize={"32px"} lineHeight={"100%"}>
            Project Details
          </Flex>
          <Flex fontWeight={"400"} fontSize={"16px"} lineHeight={"130%"}>
            To begin, you start with the basics of your project. You need a little, description, and an image that represents your project. This sets
            the stage for your staking page.
          </Flex>
        </Flex>
        <Flex col flex={7} width={["100%", "100%", "0px"]} gridGap={"28px"}>        
          <Flex col gridGap={"8px"}>
            <DetailSetupInputTitle>Collection Creator Address (used for nft collection creation)</DetailSetupInputTitle>
            <DetailSetupInput
              value={collectionCreatorAddress}
              height={"52px"}
              onChange={(e) => updateValues({ collectionCreatorAddress: e.target.value })}
            />
          </Flex>
          <Flex col gridGap={"8px"}>
            <DetailSetupInputTitle>Name of the collection (used for nft collection creation)</DetailSetupInputTitle>
            <DetailSetupInput value={nameOfCollection} height={"52px"} onChange={(e) => updateValues({ nameOfCollection: e.target.value })} />
          </Flex>
          <Flex col gridGap={"8px"}>
            <DetailSetupInputTitle>Description (max 180 char)</DetailSetupInputTitle>
            <DetailSetupInput value={description} height={"52px"} onChange={(e) => updateValues({ description: e.target.value })} />
          </Flex>
          <Flex col gridGap={"8px"}>
            <DetailSetupInputTitle>Image URL (preferably squared)</DetailSetupInputTitle>
            <DetailSetupInput
              value={imageURL}
              height={"42px"}
              placeholder={"https://"}
              onChange={(e) => updateValues({ imageURL: e.target.value })}
            />
          </Flex>
          <Flex gridGap={"34px"}>
            <Flex flex={1} col gridGap={"8px"}>
              <DetailSetupInputTitle>Total NFT Count</DetailSetupInputTitle>
              <DetailSetupNumInput value={totalNftCount} placeholder={"e.g. 1234"} onChange={(arg) => updateValues({ totalNftCount: arg })} />
            </Flex>
            <Flex display={["none", "none", "flex"]} flex={1} col gridGap={"8px"} />
          </Flex>
        </Flex>
      </Flex>
      <Flex gridGap={"32px"} flexDirection={["column", "column", "row"]}>
        <Flex col flex={3} gridGap={"8px"} width={["100%", "100%", "0px"]}>
          <Flex color={"white"} fontWeight={"700"} fontSize={"32px"} lineHeight={"100%"}>
            Staking Config
          </Flex>
          <Flex fontWeight={"400"} fontSize={"16px"} lineHeight={"130%"}>
            Specify the rewards token. Define the amount of rewards claimable daily per NFT and staking duration.
          </Flex>
        </Flex>
        <Flex col flex={7} gridGap={"28px"}>
          <Flex gridGap={"29px"} flexDirection={["column", "column", "row"]}>
            <Flex maxWidth={"100%"} col flex={"1"} gridGap={"8px"}>
              <DetailSetupInputTitle>Rewards Token</DetailSetupInputTitle>
              <CustomSelect
                value={rewardToken}
                border={"1px solid #D2C7D9"}
                borderRadius={"8px"}
                height={"52px"}
                onChange={(arg) => updateValues({ rewardToken: arg })}
              >
                <SmOption value={"APT"} selected>
                  APT
                </SmOption>
                {/* <SmOption value={"SNR"}>SNR</SmOption>
                <SmOption value={"USDC"}>USDC</SmOption> */}
              </CustomSelect>
            </Flex>
            <Flex col flex={"1"} gridGap={"8px"}>
              <DetailSetupInputTitle>Daily rewards amount / NFT</DetailSetupInputTitle>
              <DetailSetupNumInput
                value={dailyRewardAmount}
                onChange={(arg) => updateValues({ dailyRewardAmount: arg })}
                height={"52px"}
                placeholder={"e.g. 1234"}
              />
            </Flex>
          </Flex>
          <Flex gridGap={"29px"} flexDirection={["column", "column", "row"]}>
            <Flex maxWidth={"100%"} col flex={"1"} gridGap={"8px"}>
              <DetailSetupInputTitle>Duration ( total days )</DetailSetupInputTitle>
              <DetailSetupNumInput value={duration} onChange={(arg) => updateValues({ duration: arg })} placeholder={"e.g. 1234"} />
            </Flex>
            <Flex col flex={"1"} />
          </Flex>
          <Flex col gridGap={"8px"}>
            <DetailSetupInputTitle>Total amount to deposit</DetailSetupInputTitle>
            <Flex mr={"auto"} bg={"#382247"} p={"6px"} borderRadius={"4px"} fontWeight={"400"} fontSize={"16px"} lineHeight={"130%"}>
              {!totalNftCount || !dailyRewardAmount || !duration ? 0 : totalNftCount * dailyRewardAmount * duration} {rewardToken} has to be paid to
              your pool for your staking reward.
            </Flex>
          </Flex>
        </Flex>
      </Flex>
    </>
  );
};

const SecondStepSection = () => {
  const { twitterLink, discordLink, telegramLink } = useAppSelector((store) => store.settingDetailInfor.step2);
  const dispatch = useAppDispatch();
  const updateValues = (arg: object) => {
    dispatch(setDetailSettingStep2Value({ twitterLink, discordLink, telegramLink, ...arg }));
  };
  return (
    <>
      <Flex gridGap={"32px"} flexDirection={["column", "column", "row"]}>
        <Flex col flex={3} gridGap={"8px"} width={["100%", "100%", "0px"]}>
          <Flex color={"white"} fontWeight={"700"} fontSize={"32px"} lineHeight={"100%"}>
            Contact Details
          </Flex>
          <Flex fontWeight={"400"} fontSize={"16px"} lineHeight={"130%"}>
            Add link of your accounts.
          </Flex>
        </Flex>
        <Flex col flex={7} width={["100%", "100%", "0px"]} gridGap={"28px"}>
          <Flex col gridGap={"8px"}>
            <DetailSetupInputTitle>Twitter</DetailSetupInputTitle>
            <DetailSetupInput value={twitterLink} placeholder={"https://"} onChange={(e) => updateValues({ twitterLink: e.target.value })} />
          </Flex>
          <Flex col gridGap={"8px"}>
            <DetailSetupInputTitle>Discord</DetailSetupInputTitle>
            <DetailSetupInput value={discordLink} placeholder={"https://"} onChange={(e) => updateValues({ discordLink: e.target.value })} />
          </Flex>
          <Flex col gridGap={"8px"}>
            <DetailSetupInputTitle>Telegram</DetailSetupInputTitle>
            <DetailSetupInput value={telegramLink} placeholder={"https://"} onChange={(e) => updateValues({ telegramLink: e.target.value })} />
          </Flex>
        </Flex>
      </Flex>
    </>
  );
};
const LastStepSection = () => {
  const detailSetupVaules = useAppSelector((store) => store.settingDetailInfor);
  return (
    <>
      <Flex gridGap={"32px"} flexDirection={["column", "column", "row"]}>
        <Flex col flex={3} gridGap={"8px"} width={["100%", "100%", "0px"]}>
          <Flex color={"white"} fontWeight={"700"} fontSize={"32px"} lineHeight={"100%"}>
            Confirmation
          </Flex>
          <Flex fontWeight={"400"} fontSize={"16px"} lineHeight={"130%"}>
            Confirm your given data.
          </Flex>
        </Flex>
        <Flex col flex={7} width={["100%", "100%", "0px"]} gridGap={"28px"}>
          <Flex col gridGap={"8px"}>
            <DetailSetupInputTitle>Collection Creator Address</DetailSetupInputTitle>
            <ConfirmValueBox>{detailSetupVaules.step1.collectionCreatorAddress || <Box color={"red"}>none</Box>}</ConfirmValueBox>
          </Flex>
          <Flex col gridGap={"8px"}>
            <DetailSetupInputTitle>Name of the collection (max 40 char)</DetailSetupInputTitle>
            <ConfirmValueBox>{detailSetupVaules.step1.nameOfCollection || <Box color={"red"}>none</Box>}</ConfirmValueBox>
          </Flex>
          <Flex col gridGap={"8px"}>
            <DetailSetupInputTitle>Description (max 180 char)</DetailSetupInputTitle>
            <ConfirmValueBox>{detailSetupVaules.step1.description || <Box color={"red"}>none</Box>}</ConfirmValueBox>
          </Flex>
          <Flex col gridGap={"8px"}>
            <DetailSetupInputTitle>Image URL (preferably squared)</DetailSetupInputTitle>
            <ConfirmValueBox>{detailSetupVaules.step1.imageURL || <Box color={"red"}>none</Box>}</ConfirmValueBox>
          </Flex>
          <Flex gridGap={"34px"}>
            <Flex flex={1} col gridGap={"8px"}>
              <DetailSetupInputTitle>Total NFT Count</DetailSetupInputTitle>
              <ConfirmValueBox>{detailSetupVaules.step1.totalNftCount || <Box color={"red"}>none</Box>}</ConfirmValueBox>
            </Flex>
            <Flex display={["none", "none", "flex"]} flex={1} col gridGap={"8px"} />
          </Flex>
        </Flex>
      </Flex>
      <Flex gridGap={"32px"} flexDirection={["column", "column", "row"]}>
        <Flex col flex={3} gridGap={"8px"} width={["100%", "100%", "0px"]} />
        <Flex col flex={7} gridGap={"28px"}>
          <Flex gridGap={"29px"} flexDirection={["column", "column", "row"]}>
            <Flex maxWidth={"100%"} col flex={"1"} gridGap={"8px"}>
              <DetailSetupInputTitle>Rewards Token</DetailSetupInputTitle>
              <ConfirmValueBox>{detailSetupVaules.step1.rewardToken || <Box color={"red"}>none</Box>}</ConfirmValueBox>
            </Flex>
            <Flex col flex={"1"} gridGap={"8px"}>
              <DetailSetupInputTitle>Daily rewards amount / NFT</DetailSetupInputTitle>
              <ConfirmValueBox>{detailSetupVaules.step1.dailyRewardAmount || <Box color={"red"}>none</Box>}</ConfirmValueBox>
            </Flex>
          </Flex>
          <Flex gridGap={"29px"} flexDirection={["column", "column", "row"]}>
            <Flex maxWidth={"100%"} col flex={"1"} gridGap={"8px"}>
              <DetailSetupInputTitle>Duration ( total days )</DetailSetupInputTitle>
              <ConfirmValueBox>{detailSetupVaules.step1.duration || <Box color={"red"}>none</Box>}</ConfirmValueBox>
            </Flex>
            <Flex maxWidth={"100%"} col flex={"1"} />
          </Flex>
          <Flex col gridGap={"8px"}>
            <DetailSetupInputTitle>Total amount to deposit</DetailSetupInputTitle>
            <Flex mr={"auto"} bg={"#382247"} p={"6px"} borderRadius={"4px"} fontWeight={"400"} fontSize={"16px"} lineHeight={"130%"}>
              {!detailSetupVaules.step1.totalNftCount || !detailSetupVaules.step1.dailyRewardAmount || !detailSetupVaules.step1.duration
                ? 0
                : detailSetupVaules.step1.totalNftCount * detailSetupVaules.step1.dailyRewardAmount * detailSetupVaules.step1.duration}{" "}
              {detailSetupVaules.step1.rewardToken} has to be paid to your pool for your staking reward.
            </Flex>
          </Flex>
        </Flex>
      </Flex>

      <Flex gridGap={"32px"} flexDirection={["column", "column", "row"]}>
        <Flex col flex={3} gridGap={"8px"} width={["100%", "100%", "0px"]} />
        <Flex col flex={7} width={["100%", "100%", "0px"]} gridGap={"28px"}>
          <Flex col gridGap={"8px"}>
            <DetailSetupInputTitle>Twitter</DetailSetupInputTitle>
            <ConfirmValueBox>{detailSetupVaules.step2.twitterLink || <Box color={"red"}>none</Box>}</ConfirmValueBox>
          </Flex>
          <Flex col gridGap={"8px"}>
            <DetailSetupInputTitle>Discord</DetailSetupInputTitle>
            <ConfirmValueBox>{detailSetupVaules.step2.discordLink || <Box color={"red"}>none</Box>}</ConfirmValueBox>
          </Flex>
          <Flex col gridGap={"8px"}>
            <DetailSetupInputTitle>Telegram</DetailSetupInputTitle>
            <ConfirmValueBox>{detailSetupVaules.step2.telegramLink || <Box color={"red"}>none</Box>}</ConfirmValueBox>
          </Flex>
        </Flex>
      </Flex>
    </>
  );
};

export default SetupDetailPage;
